import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    titleWorkspaces: string;
    titleHome: string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Sheet title shown when viewing the workspaces navigation */
            titleWorkspaces: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspacesNavigationSheet.titleWorkspaces?c=2qdcenpfm5ojs", defaultMessage: "Workspaces" }));
                },
                enumerable: true,
                configurable: true
            },
            /** Sheet title shown when the homepage navigation is enabled */
            titleHome: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => __intl__.intl().formatMessage({ id: "WorkspacesNavigationSheet.titleHome?c=2wjsbag9mz9hy", defaultMessage: "Home" }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
